import { render, staticRenderFns } from "./add-location.vue?vue&type=template&id=2f86d328&scoped=true"
import script from "./add-location.vue?vue&type=script&lang=js"
export * from "./add-location.vue?vue&type=script&lang=js"
import style0 from "./add-location.vue?vue&type=style&index=0&id=2f86d328&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f86d328",
  null
  
)

export default component.exports